import en from "./locales/en/shared.json"
import esMx from "./locales/es_MX/shared.json"

// The "shared" namespace carries the copy of shared components. Each app
// registers these catalogues with its own i18next instance.
export const SHARED_NS = "shared"

export const sharedCatalogues = { en, es_MX: esMx } as const

export { default as initI18n } from "./init"
// Locale codes, BCP-47 mapping and the fallback
export * from "./locales"
// Use with the namespace: const { t } = useT("shared")
export { Trans, useTranslation as useT } from "react-i18next"
